module.exports = __webpack_public_path__ + "static/education-ff31dd613798c1a90df14bfe7ddf8efa.png";